import React, { Fragment } from "react";
import { Progress, Row, Col } from "reactstrap";
import { number } from "prop-types";

function ProgressBar({ step }) {
  let progressValue;

  switch (step) {
    default:
    case 0:
      progressValue = 5;
      break;
    case 1:
      progressValue = 100;
      break;
  }

  return (
    <Fragment>
      <Row className="mb-2">
        <Col className="text-left">Input Secret Key</Col>
        <Col className="text-right">Complete</Col>
      </Row>
      <Progress value={progressValue} color="green" />
    </Fragment>
  );
}

ProgressBar.propTypes = {
  step: number.isRequired,
};

ProgressBar.defaultProps = {
  step: 0,
};

export default ProgressBar;
